module.exports = __webpack_public_path__ + "img/exemplo-sobre.73536e59.png";